import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const scrollTo = (id) => {
    setMenuOpen(false);
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  return (
    <>
      <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
        <div className="nav-logo">NİŞANTAŞI</div>

        <div className="nav-right">
          <button className="nav-link" onClick={() => scrollTo('barbers')}>Ustalar</button>
          <button className="nav-link" onClick={() => scrollTo('services')}>Hizmetler</button>
          <button className="nav-link" onClick={() => scrollTo('contact')}>İletişim</button>
          <button className="nav-btn" onClick={() => scrollTo('barbers')}>Randevu Al</button>
        </div>
      </nav>

      {/* Hamburger - fixed, outside nav */}
      <button
        className={`hamburger${menuOpen ? ' active' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Menü"
      >
        <span className="ham-line" />
        <span className="ham-line" />
        <span className="ham-line" />
      </button>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
        <div className="mobile-menu-bg" onClick={() => setMenuOpen(false)} />
        <div className="mobile-menu-content">
          <div className="mobile-menu-header">
            <span className="mobile-menu-logo">NİŞANTAŞI</span>
            <span className="mobile-menu-sub">Erkek Kuaför Salonu</span>
          </div>
          <div className="mobile-menu-ornament">
            <div className="line" />
            <div className="diamond" />
            <div className="line" />
          </div>
          <div className="mobile-menu-links">
            <button className="mobile-link" onClick={() => scrollTo('barbers')}>
              <span className="mobile-link-num">01</span>
              <span className="mobile-link-text">Ustalar</span>
              <span className="mobile-link-arrow">&rarr;</span>
            </button>
            <button className="mobile-link" onClick={() => scrollTo('services')}>
              <span className="mobile-link-num">02</span>
              <span className="mobile-link-text">Hizmetler</span>
              <span className="mobile-link-arrow">&rarr;</span>
            </button>
            <button className="mobile-link" onClick={() => scrollTo('contact')}>
              <span className="mobile-link-num">03</span>
              <span className="mobile-link-text">İletişim</span>
              <span className="mobile-link-arrow">&rarr;</span>
            </button>
          </div>
          <button className="mobile-cta" onClick={() => scrollTo('barbers')}>
            <span className="btn-shine" />
            Randevu Al
          </button>
          <div className="mobile-menu-footer">
            <p>Premium Erkek Kuaförü</p>
          </div>
        </div>
      </div>
    </>
  );
}
